import { TransporterJSON } from "./json/transporterJSON";

export class Transporter {
    constructor(public id: number, public name: string) {}

    static fromJSON(json: TransporterJSON): Transporter {
        return new Transporter(json.external_id, json.display_name);
    }
}
